// export const API_URL = "http://67.4.212.216:8001";

export let API_URL = process.env.NODE_ENV === 'development' ?
    //'http://localhost:8787/'
    'https://api.rotate.group/'
    : 'https://api.rotate.group/'

export const SSO_URL = 'https://sso.rotate.group/';
export const DISCORD_SERVICE_URL = 'https://discord.rotate.group/';
export const DISCORD_GUILD = '724795733517271120';
export const CARRIER_ID = "5764f992-543e-4c30-8a7e-4b01a1798579";
